import { defineComponent as _defineComponent } from 'vue'
import {computed, ref, watchEffect} from "@nuxtjs/composition-api";
import { useToggle } from "@vueuse/core";
import IconCircleCheckSolid from "assets/svg/circle-check-solid.svg?inline";
import IconCircleRegular from "assets/svg/circle-regular.svg?inline";
import {isFunction} from "lodash";

interface Option {
  value: string | number;
  label: string;
  disabled?: boolean;
  query?: Record<string, any>;
}

type ExtraQuery =
    | Record<string, any>
    | ((option: Option) => Record<string, any>);


export default /*#__PURE__*/_defineComponent({
  __name: 'filter-item',
  props: {
    hasAll: { type: Boolean },
    allValue: { default: "" },
    title: { default: "" },
    value: { default: "" },
    name: null,
    path: { default: "" },
    extraQuery: { type: [Object, Function], default: () => ({}) },
    allQuery: null,
    options: { default: () => [] }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (name: "input", value: string | number): void;
  (name: "change", value: string | number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { hasAll?: boolean, allValue: string | number, title: string, value: string | number, name: string, path: string, extraQuery: ExtraQuery, allQuery?: Record<string, any>, options: Array<Option> }




// const modelValue = useVModel(props, "value", emit, {
//   eventName: "input",
// });
const max = 6;
const [isExpand, toggleIsExpand] = useToggle(false);
const showExpand = computed(() => props.options.length >= max);

const selectedIndex = computed(() => props.options.findIndex(item => item.value === props.value))
watchEffect(() => {
  if (selectedIndex.value >= (props.hasAll ? max - 1 : max)) {
    toggleIsExpand(true)
  }
})

const getItemPath = (option: Option) => {
  return {
    path: props.path,
    query: isFunction(props.extraQuery)
        ? props.extraQuery(option)
        : {
          ...props.extraQuery,
          [props.name]: option.value,
        },
  };
};


// const onChange = () => {
//   emit("change", modelValue.value);
// };

return { __sfc: true,props, emit, max, isExpand, toggleIsExpand, showExpand, selectedIndex, getItemPath, IconCircleCheckSolid, IconCircleRegular }
}

})